/* eslint-disable camelcase */
import { TrackingAction, TrackingCategory, trackingService } from './tracking.service';

export const AFFILIATE_CODE_ID = 'affiliation';

// const tdconv = (process as any).browser && window.tdconv;

export class AffiliateService {
  /**
   *
   * @param {number | string} order_id Unique identifier of an order.
   * @param {number | string} order_value Total value of the transaction.
   * @param {string | undefined} coupon The coupon used by a customer for the transaction.
   * @param {string} currency The currency used for the purchase.
   */
  static handleAffiliateTracking(
    order_id: number | string,
    order_value: number | string,
    coupon: string | undefined,
    currency: string,
  ) {
    if (window.tdconv) {
      console.log('Sending affiliate notification:');
      const tdObj = {
        transactionId: order_id,
        ordervalue: order_value,
        voucher: coupon,
        currency: `${currency}`,
        event: 420800,
      };
      console.log(tdObj);
      window.tdconv('init', '2310890', { element: 'iframe' });
      window.tdconv('track', 'sale', tdObj);
      trackingService.event(TrackingCategory.Marketing, TrackingAction.AFFILIATE_PURCHASE);
      console.log('Send successfully.');
    } else {
      console.log('No affiliation configured.');
    }
  }
}
